import { Stack } from '@mantine/core';

import dt from '~/domains/contest/domains/manage/domains/common/testing.const';
import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';

import { FieldSwitch } from '../../fields/FieldSwitch/FieldSwitch';
import type { NormalizedBaseSection } from '../../../common/context/types/store';

export function BaseSectionComponent({ section }: { section: NormalizedBaseSection }) {
  return (
    <Stack spacing="xl" pt={{ base: 'lg', sm: 'sm' }}>
      {section.label && (
        <Title
          data-test-id={dt.section(section.key, 'label')}
          tag="h2"
          variant={{ base: 'subhead-medium', sm: 'subhead-large' }}
        >
          {section.label}
        </Title>
      )}
      {section.description && (
        <Text data-test-id={dt.section(section.key, 'description')}>{section.description}</Text>
      )}

      <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={32}>
        {section.fields.map((fieldKey) => (
          <FieldSwitch fieldKey={fieldKey} key={fieldKey} sectionKey={section.key} />
        ))}
      </Stack>
    </Stack>
  );
}
